export default __webpack_public_path__ + "static/media/copy-to-clipboard.b907f0a9.svg";